export default {
      id: "arrow-down-usage",
      viewBox: "0 0 33 31",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }